type WindowState = {
  timestamps: number[];
};

const store: Record<string, WindowState> = {};

export const checkRateLimit = (
  key: string,
  limit: number,
  windowMs: number
): { allowed: boolean; retryIn: number; remainingMs: number } => {
  const now = Date.now();
  if (!store[key]) {
    store[key] = { timestamps: [] };
  }
  const bucket = store[key];
  bucket.timestamps = bucket.timestamps.filter(ts => now - ts < windowMs);
  if (bucket.timestamps.length >= limit) {
    const retryIn = windowMs - (now - bucket.timestamps[0]);
    return { allowed: false, retryIn, remainingMs: retryIn };
  }
  bucket.timestamps.push(now);
  return { allowed: true, retryIn: 0, remainingMs: 0 };
};
